const certifications = [
  'FDA Drug Manufacturing License',
  'ISO 9001:2015 & WHO/GMP Standards',
  'ISO 17025 Certification',
];

export default function Manufacturing() {
  const handleNav = (href: string) => {
    const el = document.querySelector(href);
    if (el) el.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <section id="manufacturing" className="py-24 px-6 bg-white">
      <div className="max-w-7xl mx-auto">
        <div className="bg-gray-50 rounded-2xl overflow-hidden grid md:grid-cols-2 gap-0">
          {/* Left Content */}
          <div className="p-12 flex flex-col justify-center">
            <div className="flex items-center gap-3 mb-3">
              <span className="w-8 h-0.5 bg-red-500 inline-block" />
              <p className="text-red-600 text-sm font-semibold uppercase tracking-widest">Compliance You Can Trust</p>
            </div>
            <h2 className="text-3xl font-bold text-gray-900 mb-4 leading-snug" style={{ fontFamily: "'Playfair Display', serif" }}>
              Setting the Standard in Regenerative Medicine Manufacturing
            </h2>
            <p className="text-gray-600 text-sm mb-6 leading-relaxed">
              Our U.S.-based manufacturing and distribution partner leads the industry in Regenerative Medicine with certifications including:
            </p>
            <ul className="space-y-3 mb-8">
              {certifications.map((cert) => (
                <li key={cert} className="flex items-center gap-3">
                  <div className="w-7 h-7 flex items-center justify-center rounded-full bg-red-100">
                    <i className="ri-award-fill text-red-600 text-sm" />
                  </div>
                  <span className="text-gray-700 text-sm font-medium">{cert}</span>
                </li>
              ))}
            </ul>
            <button
              onClick={() => handleNav('#contact')}
              className="inline-block self-start px-7 py-3 bg-blue-900 text-white font-semibold rounded-md hover:bg-blue-800 transition-colors cursor-pointer whitespace-nowrap text-sm"
            >
              About Our Manufacturing and Distribution Partner
            </button>
          </div>

          {/* Right Image */}
          <div className="h-[460px] md:h-auto overflow-hidden">
            <img
              src="https://readdy.ai/api/search-image?query=modern%20regenerative%20medicine%20laboratory%20facility%20with%20advanced%20scientific%20equipment%2C%20clean%20sterile%20environment%2C%20professional%20medical%20manufacturing%20lab%2C%20bright%20white%20lighting%2C%20high-tech%20biotechnology%20research%20equipment%2C%20organized%20workspace%2C%20white%20and%20steel%20surfaces%2C%20precision%20laboratory%20instruments&width=600&height=460&seq=1&orientation=landscape"
              alt="Manufacturing Facility"
              className="w-full h-full object-cover object-top"
            />
          </div>
        </div>
      </div>
    </section>
  );
}
